import styled from 'styled-components';

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  z-index: 100;
  opacity: 0.7;
`;
const Title = styled.h2`
  font-size: 24px;
  line-height: 26px;
  font-weight: 500;
  color: #475466;
`;
